import React, { useState } from 'react';

import StockMobileSidePanel from '@/components/StockMobileSidePanel';
import { OptionType } from '@/typings/common';
import StockFilterSelect from '@/components/StockFilterSelect';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  getStockFilterParams,
  setCarVat,
  setPage,
} from '@/store/reducers/cars-stock';
import { convertFilterParamsToOptionsByKey } from '@/modules/CarsStock/components/common.helpers';

import {
  FilterButton,
  FilterButtonWrapper,
  MobileFilterItemWrapper,
} from '../../../../../../../common.styles';

function VatFilter() {
  const dispatch = useTypedDispatch();
  const stockFilterParams = useTypedSelector(getStockFilterParams);
  const selectedVat =
    useTypedSelector(getSelectedFilters).selectedParams.selectedVat;

  const vatOptions = convertFilterParamsToOptionsByKey(
    stockFilterParams,
    'vats'
  );

  const [isOpened, setOpened] = useState(false);

  const handleSidePanelOpen = () => {
    setOpened(true);
  };

  const handleSidePanelClose = () => {
    setOpened(false);
  };

  const handleChangeVats = (vat: OptionType) => {
    dispatch(setCarVat(vat));
    dispatch(setPage(1));
  };

  const handleClearVats = () => {
    dispatch(setCarVat({ label: '', value: '' }));
  };

  return (
    <StockMobileSidePanel
      title="НДС"
      zIndex={10001}
      isInnerSidePanel
      isOpened={isOpened}
      onOpen={handleSidePanelOpen}
      onClose={handleSidePanelClose}
    >
      <MobileFilterItemWrapper>
        <StockFilterSelect
          value={selectedVat}
          options={vatOptions}
          onChange={handleChangeVats}
          onClear={handleClearVats}
        />
      </MobileFilterItemWrapper>

      <FilterButtonWrapper>
        <FilterButton onClick={handleSidePanelClose}>Применить</FilterButton>
      </FilterButtonWrapper>
    </StockMobileSidePanel>
  );
}

export default VatFilter;
